export default __webpack_public_path__ + "static/media/AugDom2024.046c3641.png";